import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BnNgIdleService } from "bn-ng-idle";
import Swal from "sweetalert2";
import "rxjs/Rx";
import { SessionTimerService } from "session-expiration-alert";
import { interval, Subscription } from "rxjs";
import { DatePipe } from "@angular/common";
import { SecurityService } from './services/security/security.service';
import { GuiasService } from './services/guias/guias.service';
import { environment } from "environments/environment";




@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  providers:[  DatePipe]
})
export class AppComponent implements OnInit {
  cantidadSession;
  SessionTime;
  contador;
  startTimer = true;
  id_componente_padre : number[] = [44,27,47];
  //idGuia_Padre : number[] = [1,4,21,25,55,30,34,44,89,64,37,41,50,59,67,70,73,76,84,92,100,103,107,110,113,116,127,144,149,131,160,233];
/*   idGuia_Padre : number[] = [environment.ID_MONEDA,environment.ID_BANCO,460,464,469,473,476,480,483,489,494,498,503,506,509,512,515,523,
    528,531,534,537,540,543,546,549,560,564,568,571,575,580,586,591,627]; */
    idGuia_Padre : number[] = [  
      environment.ID_MONEDA,
      environment.ID_BANCO,
      environment.ID_PAGO,
      environment.ID_TIPO_COMPROBANTEIF,
      environment.ID_TIPO_DOC_IDENTIFICACION,
      environment.ID_IGV_EXONERADO,
      environment.ID_COMPROBANTE_EMITIDO,
      environment.ID_COMPROBANTE_CONTA,
      environment.ID_ROL_CONTACTO,
      environment.ID_CONDICION,
      environment.ID_TIPO_CONTACTO,
      environment.ID_TIPO_CONFORMIDA,
      environment.ID_TIPO_COMPROBANTE,
      environment.ID_TIPO_EMISION,
      environment.ID_RETENCION_FONDO,
      environment.ID_RETENCION,
      environment.ID_TIPO_XLS,
      environment.ID_TIPO_PLANTILLA,
      environment.ID_TIPO_CUENTA,
      environment.ID_BANCO_IF,
      environment.ID_PARTICIPANTE,
      environment.ID_RUT,
      environment.ID_TIPO_SOLICITUD,
      environment.ID_TIPO_OPERACION,
      environment.ID_TIPO_PAGOCPE,
      environment.ID_TIPO_OPERACION_NC,
      environment.ID_TIPO_OPERACION_ND,
      environment.ID_TIPO_SERVICIO,
      environment.ID_TIPO_PAGARE,
      environment.ID_TIPO_PROCESO,
      environment.ID_TIPO_ADJUNTO,
      environment.ID_FACTOR_REPRESENTANTE,
      environment.ID_FACTOR_DATOS,
      environment.ID_FACTOR_BANCO,
      environment.ID_TIPO_FACTURACION];

  color2 : any;
  color : any;
   cont = 8;

   public intervaloSub: Subscription;
   securitySub: Subscription;

  constructor(private guiasService: GuiasService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    public sessionTimer: SessionTimerService,
    private securityService: SecurityService    
  ) {

    this.color = sessionStorage.getItem("color2");
    this.color2 = sessionStorage.getItem("color");
    this.CargarListaguias(this.idGuia_Padre);
    this.bnIdle.startWatching(6000).subscribe(res => {
      if (res) {
        
        Swal.fire({
          title: "Session Cerrada",
          text: "Sessión cerrada por inactividad",
          type: "warning",
          allowOutsideClick: false
        }).then(resp => {
          if (resp.value == true) {
            this.router.navigate(["/login"]);
          }
        });
      }
    }); 
  }


  ngOnInit() {
    const validarTiempoSession =interval(10000);   
    document.documentElement.style.setProperty('--innova-primary', this.color);
    document.documentElement.style.setProperty('--innova-default', this.color2);
    // validarTiempoSession.subscribe( () => {
    //   let recortado = sessionStorage.getItem('sessionTime');
    //   if (recortado) {
    //     let tiempoSession = recortado.split('-');
    //     let fecha = new Date();
        
    //     let fechaActual = (fecha.getHours() + '-' + Number(fecha.getMinutes()));
    //  let fechaActual2 =  fechaActual.split('-');
    //     if ((Number(fechaActual2[0])- Number(tiempoSession[0])) >= 2  && Math.abs(Number(fechaActual2[1]) -  Number(tiempoSession[1])) > 30 ) 
    //     {
    //      // this.router.navigate(["/login"]);
  
    //       const validarTiempoResouesta = interval(1000); 
    //       this.intervaloSub =validarTiempoResouesta.subscribe(()=>{   
    //         this.cont -- ;
    //         if (this.cont <= 0) {
    //           this.intervaloSub.unsubscribe();
    //           this.cont = 8;
    //           Swal.close();
    //           this.router.navigate(["/login"])
    //         }
    //       })
    //         Swal.fire({
    //         title: 'Cierre de Sesión Automatica',
    //         text: 'Se cerrara sesión. Desea continuar la sesión actual?',
    //         type: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Si, continuar',
    //         cancelButtonText: 'No, cerrar sesión.',
    //         reverseButtons: true,
    //         allowOutsideClick: false
    //       }).then((result) => {
    //         if (result.value) {
    //           this.intervaloSub.unsubscribe();
    //           this.cont = 8;
    //           sessionStorage.setItem('sessionTime',   fecha.getHours().toString() + "-"+ fecha.getMinutes());
    //         } else if ( result.dismiss === Swal.DismissReason.cancel ) {
    //           this.intervaloSub.unsubscribe();
    //           this.cont = 8;
    //           this.router.navigate(["/login"])
    //         }
    //       })
    //     } 
    //   }
    // })
  }

  Refresh(){
    this.CargarListaguias(this.idGuia_Padre);
  }

  CargarListaguias(idGuia_Padre : any){ 
      for (let index = 0; index < idGuia_Padre.length; index++) {
        const idGuia_Padre2 = idGuia_Padre[index];
        this.securitySub = this.securityService.ObtenerListaGuias(idGuia_Padre2)
        .subscribe(
          resp => {
            switch (idGuia_Padre2){
              case environment.ID_MONEDA:
                this.guiasService.setDataTipoMoneda(resp);
                break;
              case environment.ID_BANCO:
                this.guiasService.setDataTipoBanco(resp);
                break;
              case environment.ID_PAGO:
                this.guiasService.setDataTipoPago(resp);
                break;
              case environment.ID_TIPO_COMPROBANTEIF:
                this.guiasService.setDataTipoComprobanteIF(resp);
                break;  
              case environment.ID_TIPO_CONTACTO:
                this.guiasService.setDataTipoContacto(resp);
                break;
              case environment.ID_TIPO_DOC_IDENTIFICACION:
                this.guiasService.setDataTipoDocumento(resp);
                break;
              case environment.ID_IGV_EXONERADO:
                this.guiasService.setDataIgvExonerado(resp);
                break;
              case environment.ID_ROL_CONTACTO:
                this.guiasService.setDataRolContacto(resp);
                break;
              case environment.ID_TIPO_CUENTA:
                this.guiasService.setDataTipoCuenta(resp);
                break;
              case environment.ID_TIPO_COMPROBANTE:
                this.guiasService.setDataTipoComprobante(resp);
                break;
              case environment.ID_COMPROBANTE_EMITIDO:
                this.guiasService.setDataComprobanteEmitido(resp);
                break; 
              case environment.ID_COMPROBANTE_CONTA:
                this.guiasService.setDataComprobanteContabilizado(resp);
                break;
              case environment.ID_CONDICION:
                this.guiasService.setDataCondicion(resp);
                break;
              case environment.ID_TIPO_CONFORMIDA:
                this.guiasService.setDataTipoConformidad(resp);
                break; 
              case environment.ID_TIPO_EMISION:
                this.guiasService.setDataTipoEmision(resp);
                break; 
              case environment.ID_RETENCION_FONDO:
                this.guiasService.setDataRetencionBase(resp);
                break;
              case environment.ID_RETENCION:
                this.guiasService.setDataRetencion(resp);
                break;
              case environment.ID_TIPO_XLS:
                this.guiasService.setDataTipoXls(resp);
                break;
              case environment.ID_TIPO_PLANTILLA:
                this.guiasService.setDataTipoPlanilla(resp);
                break;
              case environment.ID_BANCO_IF:
                this.guiasService.setDataTipoBancoIF(resp);
                break;
              case environment.ID_PARTICIPANTE:
                this.guiasService.setDataParticipante(resp);
                break;
              case environment.ID_RUT:
                this.guiasService.setDataRutTitular(resp);
                break; 
              case environment.ID_TIPO_SOLICITUD:
                this.guiasService.setDataTipoSolicitud(resp);
                break;
              case environment.ID_TIPO_OPERACION:
                this.guiasService.setDataTipoOperacion(resp);
                break;
              case environment.ID_TIPO_PAGOCPE:
                this.guiasService.setDataTipoPagoCPE(resp);
                break;
              case environment.ID_TIPO_OPERACION_NC:
                this.guiasService.setDataTipoOperacioNC(resp);
                break;
              case environment.ID_TIPO_OPERACION_ND:
                this.guiasService.setDataTipoOperacionND(resp);
                break;
              case environment.ID_TIPO_ADJUNTO:
                this.guiasService.setDataTipoAdjunto(resp);
                break;
              case environment.ID_FACTOR_REPRESENTANTE:
                this.guiasService.setDataRepresentanteIF(resp);
                break;
              case environment.ID_TIPO_SERVICIO:
                this.guiasService.setDataTipoServicio(resp);
                break;                 
              case environment.ID_FACTOR_BANCO:
                this.guiasService.setDataEntidadFinanciera(resp);
                break;    
              case environment.ID_TIPO_FACTURACION:
                this.guiasService.setDataTipoFacturacion(resp);
                break;                                                                      
            }
          }
        );  
      }
  }

  
}
